<template id="route">
    <div v-touch="touch">
        <headerbar :preselection="preselection" :stepflow="stepflow" :headerLabel="stepLabel" :stepId="stepId" @go-prev="goPrev"></headerbar>

        <div class="container no-padding stepContainer">
            <step v-for="( step, index ) in stepflow" :key="step.id" :step="step" :index="index" :preselection="preselection" :fare="fare" :payment="payment" :bill="bill" :revision="revision" :class="boxClass" :f="f" :f1="f1" :f2="f2" :gas="gas"
             @step-completed="onStepCompleted" @set-fare="saveFare" @set-payment="savePayment" @set-bill="saveBill" @update-header="updateHeader"></step>
        </div>

        <exit v-if="routeCompleted" :exitlist="exitlist" :exitid="exitid" :fare="selected_fare" :payment="selected_payment" :bill="selected_bill" @gotolaststep="gotolaststep" @reconfig="reconfig"></exit>
        
        <config-summary v-if="changeconfig" :stepflow="stepflow" :exitid="exitid" :fare="selected_fare" :payment="selected_payment" :bill="selected_bill" @closeconfigsummary="closeconfigsummary" @changeflow-route="changeflow"></config-summary>
    </div>
</template>


<script>

import Vue from 'vue'
import Vue2TouchEvents from 'vue2-touch-events' 
Vue.use(Vue2TouchEvents)

import Headerbar from './Headerbar.vue';
import Step from './Step.vue';
import Exit from './Exit.vue';
import ConfigSummary from './ConfigSummary.vue';

import { steplist } from "./model/steplist.js";
import { exitlist } from "./model/exitlist.js";


export default {
    name: "Route",

    components: {
        Headerbar,
        Step,
        Exit,
        ConfigSummary
    },

    props: ['defaultValue', "f", "f1", "f2", "gas"],

    data: function () {
        return {
            stepflow: [],
            stepLabel: [],
            stepsValues: [],
            boxClass: '',
            exitOpen: false,
            fare: 'null',
            payment: 'null',
            bill: 'null',
            changeconfig: false,
            product: 'link',
            steplist: {},
            preselection : {}
        };
    },

    created: function () {
        console.log('Step-Cart Route created' );

        this.preselection = this.defaultValue;

        //console.log('sf-route route created steplist', this.steplist);
        this.routeCompleted = false;
        this.selected_fare = 'null';
        this.selected_payment = 'null';
        this.selected_bill = 'null';
        this.revision = false;
        this.steplist = steplist[this.product];
        this.exitlist = exitlist[this.product];
        this.stepId = 0;
    },
    destroied: function () {
    },
    mounted: function () {
        console.log('Step-Cart Route mounted' );

        this.resetData();
    },

    computed: {
        touch: function () {
            return {
                x: this.x,
                y: this.y,
                methods: true
            }
        }
    },

    methods: {

        saveFare: function (val) {
            console.log('Route saveFare', val );
            this.fare = val;
            this.selected_fare = val;
        },

        savePayment: function (val) {
            console.log('Route savePayment', val );

            this.selected_payment = val;
        },

        saveBill: function (val) {
            console.log('Route saveBill', val );

            this.selected_bill = val;
        },

        updateHeader: function (val) {
            console.log('Route updateHeader', val );

            this.preselection = val;
        },

        resetData: function () {
            console.log('Route resetData' );

            this.routeCompleted = false;

            this.updateStep({
                id: this.steplist.id,
                micro_step: this.steplist.micro_step,
                type: this.steplist.type,
                subtype: this.steplist.subtype,
                label: this.steplist.label,
                intro: this.steplist.intro,
                rightbox: this.steplist.rightbox,
                event_category: this.event_category,
                questions: this.steplist.questions,
                choices: this.steplist.choices,
                choicesexplain: this.steplist.choicesexplain,
                icons: this.steplist.icons,
                event_labels: this.steplist.event_labels,
                trackingclass: this.steplist.trackingclass
            });

        },

        goStep: function (i) {
            console.log('Route goStep' );

            //RIATTIVARE*** $('[sf-component="cart-modal-exits"] .exit.active').removeClass('active');
            this.exitOpen = false;

            this.stepsValues = this.stepsValues.splice(0, i - 1);
            this.stepflow = this.stepflow.splice(0, i);

            console.log("this.stepflow.length: ", this.stepflow.length);

            this.updateStep( this.stepflow.pop() );
        },

        swipeDown: function() {
            console.log('Route swipeDown' );

            this.prevStep = this.stepflow.length-1;
            console.log('prevStep -->', this.prevStep);

            if ((this.prevStep > 0) && (!this.routeCompleted) && (!this.changeconfig)) {
                console.log('Swipe down allowed, prevStep = ', this.prevStep);
                this.goStep(this.prevStep);
            } else {
                console.log('Swipe down not allowed');
            }
        },

        goNext: function () {
            console.log('Route goNext', ' --- ');
        },

        goPrev: function() {
            console.log('Route goPrev' );

            this.prevStep = this.stepflow.length-1;
            console.log('prevStep -->', this.prevStep);

            if ((this.prevStep > 0) && (!this.routeCompleted) && (!this.changeconfig)) {
                console.log('goPrev allowed, prevStep = ', this.prevStep);
                this.goStep(this.prevStep);

            } else {
                console.log('goPrev not allowed');
            }
        },

        updateStep: function( step ) {
            console.log( 'Route updateStep', step );

            this.track( step.micro_step );

            //- update step info --
            this.stepflow.push( step );
            this.stepLabel = step.label;
            this.stepId = step.id;
            
            this.stepNumber = this.stepflow.length;
            this.boxClass = 'step-box-' + this.stepflow.length;
        },

        track: function( micro_step ) {
            console.log( 'Route track', micro_step );
            console.log( 'Route track', this.preselection );

            try {
                console.log( 'Route track micro_step', micro_step );
                console.log( 'Route track preselection', this.preselection );

                //- track analytics ---
                window.callDataLayer({ 
                    'event': 'customSubscription',
                    'macro_step': "0_Overlay_step",
                    'micro_step': micro_step,
                    'operazione': "weborder",
                    'prodotto': "LINK",
                    'commodity': "dual",
                    'settore': "residenziale",
                    'opzione': this.preselection,
                    'listino': "promo",
                });

                //- track contentn square ---
                window._uxa = window._uxa || [];
                window._uxa.push(['trackPageview', window.location.pathname+window.location.hash.replace('#','?__') + '?cs-offerta-link-luce-gas='+micro_step]);

                console.log( 'Route track micro_step', window.location.pathname+window.location.hash.replace('#','?__') + '?cs-offerta-link-luce-gas='+micro_step );
            } catch (error) {
                // tracking is not ready
            }
        },

        onStepCompleted: function (val) {
            console.log( 'Route onStepCompleted', val );
            
            this.revision = false; 

            this.stepsValues.length = val[0];
            this.stepflow = this.stepflow.splice(0, val[0] + 1);

            var pointer = this.steplist;

            console.log("steplist :", this.steplist);
            console.log('sf-route route stepsValues', this.stepsValues.length, this.stepsValues);
            console.log('sf-route route stepflow', this.stepflow.length, this.stepflow);

            for (let i = 0; i < this.stepsValues.length; i++) {
                //pointer = this.steplist.child[ 'path_' + this.stepsValues[i] ];
                pointer = pointer.child['path_' + this.stepsValues[i]];
                console.log('sf-route route move', this.stepsValues[i], pointer.child['path_' + this.stepsValues[i]]);
            }

            if (pointer.child['path_' + val[1]].action == 'step-after-config') {
                this.stepsValues.push(0);
            } else {
                this.stepsValues.push(val[1]);
            }            

            console.log('pointer', pointer);
            console.log('pointer.child', pointer.child);

            console.log('sf-route route stepflow', 'afterFor', this.stepflow);

            
            console.log('only val[1]', val[1]);
            console.log('only val', val);
            console.log('path', 'path_' + val[1]);
            console.log('sf-route route val', pointer.child['path_' + val[1]]);


            console.log('sf-route route action', pointer.child['path_' + val[1]].action);

            switch (pointer.child['path_' + val[1]].action) {
                case 'step':
                    this.updateStep({
                        id: pointer.child['path_' + val[1]].id,
                        micro_step: pointer.child['path_' + val[1]].micro_step,
                        type: pointer.child['path_' + val[1]].type,
                        subtype: pointer.child['path_' + val[1]].subtype,
                        label: pointer.child['path_' + val[1]].label,
                        intro: pointer.child['path_' + val[1]].intro,
                        rightbox: pointer.child['path_' + val[1]].rightbox,
                        event_category: pointer.child['path_' + val[1]].event_category,
                        questions: pointer.child['path_' + val[1]].questions,
                        choices: pointer.child['path_' + val[1]].choices,
                        choicesexplain: pointer.child['path_' + val[1]].choicesexplain,
                        icons: pointer.child['path_' + val[1]].icons,
                        event_labels: pointer.child['path_' + val[1]].event_labels,
                        trackingclass: pointer.child['path_' + val[1]].trackingclass
                    });

                    break;
                
                case 'step-after-config':

                    this.updateStep({
                        id: pointer.child['path_0'].id,
                        micro_step: pointer.child['path_0'].micro_step,
                        type: pointer.child['path_0'].type,
                        subtype: pointer.child['path_0'].subtype,
                        label: pointer.child['path_0'].label,
                        intro: pointer.child['path_0'].intro,
                        questions: pointer.child['path_0'].questions,
                        rightbox: pointer.child['path_0'].rightbox,
                        event_category: pointer.child['path_0'].event_category,
                        choices: pointer.child['path_0'].choices,
                        choicesexplain: pointer.child['path_0'].choicesexplain,
                        icons: pointer.child['path_0'].icons,
                        event_labels: pointer.child['path_0'].event_labels,
                        trackingclass: pointer.child['path_0'].trackingclass
                    });
                    
                    break;

                case 'exit':
                    this.track( pointer.child['path_' + val[1]].micro_step );
                    
                    console.log('sf-route route exit', pointer.child['path_' + val[1]].id);
                    console.log('sf-route route exit', '[sf-component="cart-modal-exits"] #' + pointer.child['path_' + val[1]].id);
                   
                    //RIATTIVARE*** $('[sf-component="cart-modal-exits"] #' + pointer.child['path_' + val[1]].id).addClass('active');
                    this.exitOpen = true;
                    this.exitid = pointer.child['path_' + val[1]].id;                    
                    this.routeCompleted = true;
                    
                    this.changeconfig = false;
                    break;

                default:
                    break;
            }
        },

        gotolaststep: function() {
            console.log( 'gotolaststep | Route' );

            this.exitOpen = false;                
            this.routeCompleted = false;

            this.goStep(this.stepflow.length);
        },

        reconfig: function() {
            console.log( 'Route reconfig' );

            this.changeconfig = true;
        },

        closeconfigsummary: function() {
            console.log( 'Route closeconfigsummary' );

            this.changeconfig = false;
        },

        changeflow: function (node) {
            console.log( 'Route changeflow', node );

            this.routeCompleted = false;
            this.revision = true;
            this.goStep(node);
        }
    }
}

</script>


<style lang="scss">
    //[sf-component="cart-step"][sf-version="1.0"] questo dovrebbe essere quello corretto, dove si cambia?

    $min-desktop-res: 1024px;
    $max-mobile-res: 1023px;
    $desktop-step-height: 552px;
    $mobile-step-height: 100vh;
    $headerbar-height: 85px;

    .sf-cart-modal[sf-component="cart-modal"][sf-version="1.0"] {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        //background-color: #f3f3f3;
        background-color:  rgba(51, 51, 51, 0.8);
        background-attachment: fixed;
        z-index: -10;
        opacity: 0;


        &.open {
            opacity: 1;
            z-index: 1000;
            display: flex;
            //overflow-y: auto; // cancellare quando implementato
        }

        > div {
            border-radius: 12px;
            width:1004px;
            height: 637px;
            background-color: #f3f3f3;
            margin: auto;
            overflow: hidden;
            
            @media (max-width: $max-mobile-res) {
                width: 100vw;
                height: 100vh;
                border-radius: 0px;
            }
        }

        html {
            scroll-behavior: smooth;
        }

        .tooltip-step {
            cursor: pointer;
            position: relative;
            display: inline-block;
            width: 22px;
            height: 22px;
            //background-image: url("../../assets/tooltip.svg");
            //background-image: url("http://enigaseluce.com/it_IT/static/images/listing/carrelli/tooltip.svg");
            background-image: url("/it_IT/static/images/listing/carrelli/tooltip.svg");
            background-size: contain;
            top: 5px;
            margin-left: 8px;      
        }

        .tooltip-step .tooltiptext {
            width: 182px;
            height: 66px;
            box-shadow: 0 2px 4px 2px rgba(0, 0, 0, 0.1), 0 0 30px 0 rgba(0, 0, 0, 0.08);
            visibility: hidden;
            position: absolute;
            background-color: #333;
            color: #fff;
            text-align: center;
            z-index: 1;
            opacity: 0;
            transition: opacity 0.3s;
            font-size: 14px;
            padding: 15px;
            text-align: left;
        }

        .tooltip-right {
            top: -24px;
            left: 140%;
        }

        .tooltip-right::after {
            content: "";
            position: absolute;
            top: 50%;
            right: 100%;
            margin-top: -5px;
            border-width: 7px;
            border-style: solid;
            color: #333;
            border-color: transparent #333 transparent transparent;
        }

        .tooltip-step:hover .tooltiptext {
            visibility: visible;
            opacity: 1;
        }

        .tooltip-step:hover {
            //background-image: url("../../assets/tooltip.svg");
            //background-image: url("http://enigaseluce.com/it_IT/static/images/listing/carrelli/tooltip.svg");
            background-image: url("/it_IT/static/images/listing/carrelli/tooltip.svg");
        }



        // #app {}
        
        .no-padding  { padding: 0px; }
        .no-padding-left { padding-left: 0px !important; }
        .no-padding-right { padding-right: 0px !important; }

        #app .container {
            width: 100%;
            max-width: 1004px;
            min-width: 330px;
            //padding: 0 15px;
            //display: none; 

            
        }

        .bkg-image {
            //background-image: url("../../assets/step-cart.jpg");
            //background-image: url("http://enigaseluce.com/it_IT/static/images/listing/carrelli/step-cart.jpg");
            background-image: url("/it_IT/static/images/listing/carrelli/step-cart.jpg");
            background-size: 432px;
            background-position: 596px 0px;
            background-repeat: no-repeat;

            @media (max-width: $max-mobile-res) {
                background-image: none;
            }
        }

        .header {
            color: #333;
            background-color: white;
            box-shadow: 0 8px 25px -15px rgba(154, 154, 154, 0.5);
            position: relative;
            width: 100%;
            height: $headerbar-height;
            z-index: 1000;
            top: 0px;

            .icon.icon-dropdown_up {
                font-size: 18px;
                font-weight: bold;
                transform: rotate(270deg);
                display: block;
                line-height: 30px;
            }
            
            .container {
                width: 100%;
                max-width: 1004px;
                min-width: 330px;
                padding: 15px;
                position: relative;
            }

            .back {
                cursor: pointer;
                text-align: center;
                position: absolute;
                color: #333333;
                font-size: 14px;

                @media (max-width: $max-mobile-res) {
                    top: 25px;
                    left: 18px;
                }

                span.text {
                    @media (max-width: $max-mobile-res) {
                        display: none;
                    }
                }
            }

            // .back:hover { background: #b6b6b6; }

            .progress {
                font-size: 14px;
                font-weight: normal;
            }

            .steptitle {
                font-size: 20px;
                font-weight: bold;
                position: absolute;
                top: 26px;
                left: 96px;

                &.first {
                    left: 26px;
                }

                @media (max-width: $max-mobile-res) {
                    top: 18px;
                    left: 69px;
                    line-height: 20px;
                    padding-right: 50px;
                }

                .stepid {
                    color: #b9b9b9;
                    font-size: 14px;
                    position: absolute;
                    top: 26px;
                    left: 0px;

                    @media (max-width: $max-mobile-res) {
                        top: 40px;
                    }
                }

                .commodity {
                    text-transform: lowercase;
                }
                
            }

            .sf-close {
                position: absolute;
                top: 30px;
                right: 30px;
                width: 15px;
                height: 15px;
                z-index: 9999;

                @media (max-width: $max-mobile-res) {
                    right: 15px;
                }
                
                span {
                    height: 2px;
                }
            }

            .progressbar {
                position: absolute;
                bottom: 0px;
                width: 100%;
                height: 6px;
                background-color: #eaeaea;

                .filler {
                    background-color: #ffd300;
                    height: 6px;
                    width: 0%; //da automatizzare
                }
            }

            .decoration {
                position: absolute;
                top: 15px;
                left: 77px;
                width: 4px;
                height: 48px;
                border-radius: 3px;
                background-color: #ffd300;

                @media (max-width: $max-mobile-res) {
                    top: 15px;
                    left: 50px;
                }
            }
        }
        
        .info {
            font-size: 12px;
            color: #2f460a;
        }

        .statusinfo {
            font-size: 12px;
            color: #444;
            position: absolute;
            top: 10px;
            left: 10px;
            background-color: #00000020;
            padding: 5px;
        }

        .stepContainer {
            background-attachment: fixed;
            max-width: 1004px;
            margin: auto;

            @media (max-width: $max-mobile-res) {
                max-width: 100%;
            }

            .box {
                //width: 810px;
                margin: auto;
            }

            .rightbox {
                display: block;
            }

        }

        .step {

            // border-bottom: 1px solid white; // cancellare quando implementato

            display: flex;
            justify-content: center;
            align-items: center;

            //height: calc(~"100vh - 86px");
            
            height: 552px;
            min-width: 330px;
            position: relative;
            //background-color: #7fa545;
            //background: linear-gradient(167deg, #7fa545 88%, transparent 0%), #55791e;

            //padding-top: $headerbar-height; //altezza dell'header
            padding-left: 90px;
            padding-right: 90px;
            overflow-y: hidden;	
            scroll-behavior: smooth;

            transition: 0.5s all;	

            @media (max-width: $max-mobile-res) {
                    //height: calc(100vh - 85px);
                    display: block;
                    height: 100vh;
                    padding-left: 0px;
                    padding-right: 0px;
                    overflow-y: scroll;	
            }

            &:first-child {
                &.step-box-1  { margin-top: 0; }
                &.step-box-2  { margin-top: calc(#{-$desktop-step-height} * 1 ); }
                &.step-box-3  { margin-top: calc(#{-$desktop-step-height} * 2 ); }
                &.step-box-4  { margin-top: calc(#{-$desktop-step-height} * 3 ); }
                &.step-box-5  { margin-top: calc(#{-$desktop-step-height} * 4 ); }
                &.step-box-6  { margin-top: calc(#{-$desktop-step-height} * 5 ); }
                &.step-box-7  { margin-top: calc(#{-$desktop-step-height} * 6 ); }
                &.step-box-8  { margin-top: calc(#{-$desktop-step-height} * 7 ); }
                &.step-box-9  { margin-top: calc(#{-$desktop-step-height} * 8 ); }
                &.step-box-10 { margin-top: calc(#{-$desktop-step-height} * 9 ); }
                &.step-box-11 { margin-top: calc(#{-$desktop-step-height} * 10 ); }

                /*
                @media (max-width: $max-mobile-res) {
                    &.step-box-1  { margin-top: 0; }
                    &.step-box-2  { margin-top: calc(#{-$mobile-step-height} #{-$headerbar-height} * 1 ); }
                    &.step-box-3  { margin-top: calc(#{-$mobile-step-height} #{-$headerbar-height} * 2 ); }
                    &.step-box-4  { margin-top: calc(#{-$mobile-step-height} #{-$headerbar-height} * 3 ); }
                    &.step-box-5  { margin-top: calc(#{-$mobile-step-height} #{-$headerbar-height} * 4 ); }
                    &.step-box-6  { margin-top: calc(#{-$mobile-step-height} #{-$headerbar-height} * 5 ); }
                    &.step-box-7  { margin-top: calc(#{-$mobile-step-height} #{-$headerbar-height} * 6 ); }
                    &.step-box-8  { margin-top: calc(#{-$mobile-step-height} #{-$headerbar-height} * 7 ); }
                    &.step-box-9  { margin-top: calc(#{-$mobile-step-height} #{-$headerbar-height} * 8 ); }
                    &.step-box-10 { margin-top: calc(#{-$mobile-step-height} #{-$headerbar-height} * 9 ); }
                    &.step-box-11 { margin-top: calc(#{-$mobile-step-height} #{-$headerbar-height} * 10 ); }
                }
                */


                @media (max-width: $max-mobile-res) {
                    &.step-box-1  { margin-top: 0; }
                    &.step-box-2  { margin-top: calc(#{-$mobile-step-height} * 1 ); }
                    &.step-box-3  { margin-top: calc(#{-$mobile-step-height} * 2 ); }
                    &.step-box-4  { margin-top: calc(#{-$mobile-step-height} * 3 ); }
                    &.step-box-5  { margin-top: calc(#{-$mobile-step-height} * 4 ); }
                    &.step-box-6  { margin-top: calc(#{-$mobile-step-height} * 5 ); }
                    &.step-box-7  { margin-top: calc(#{-$mobile-step-height} * 6 ); }
                    &.step-box-8  { margin-top: calc(#{-$mobile-step-height} * 7 ); }
                    &.step-box-9  { margin-top: calc(#{-$mobile-step-height} * 8 ); }
                    &.step-box-10 { margin-top: calc(#{-$mobile-step-height} * 9 ); }
                    &.step-box-11 { margin-top: calc(#{-$mobile-step-height} * 10 ); }
                }
                
            }

            .container {
                @media (max-width: $max-mobile-res) {
                    padding-bottom: 120px;
                }
            }

            &.withimage {
                padding-left: 80px;
                padding-right: 500px;

                @media (max-width: $max-mobile-res) {
                    padding-left: 0px;
                    padding-right: 0px;
                }
            }
            
            .intro {
                color: #444444;
                text-align: center;
                font-size: 24px;
                line-height: 28px;;
                font-weight: 400;
                margin: 20px 0px 15px 0px;
                padding-bottom: 12px;
                border-bottom: 2px solid #d9d9d9;

                @media (max-width: $max-mobile-res) {
                    font-size: 20px;
                }

                span {
                    font-size: 30px;
                    font-weight: bold;
                    //background: linear-gradient(to bottom,transparent 70%,#fdd300 70%,#fdd300 0);
                    background: linear-gradient(to bottom, transparent 65%, #fdd300 65%, #fdd300 90%, transparent 0);
                }
            }

            .question {
                color:#333333;
                font-size: 20px;
                font-weight: 600;
                margin: 20px 0px 15px 0px;

                @media (max-width: $max-mobile-res) {
                    text-align: center;
                    font-size: 18px;
                }
            }
        }

        .summary {
            margin: 30px 0px;
            background-color: #333333;
            -webkit-border-radius: 15px;
            -webkit-border-bottom-right-radius: 12px;
            -webkit-border-bottom-left-radius: 12px;
            -moz-border-radius: 15px;
            -moz-border-radius-bottomright: 12px;
            -moz-border-radius-bottomleft: 12px;
            border-radius: 15px;
            border-bottom-right-radius: 12px;
            border-bottom-left-radius: 12px;

            &.fare-setup {
                background-color: transparent;
                padding: 0;
                margin: 0;
            }

            &.discount-active {
                background-color: #7fa545;
                .info {
                    text-align: center;
                    color: white !important;
                }
            }

            .discount {
                color: white;
                padding: 5px 30px 5px 30px;

                .info {
                    font-size: 14px;
                    font-weight: bold;
                    text-transform: uppercase;
                    line-height: 16px;
                    color: #ffd300;
                    margin-bottom: 15px;
                    .icons {
                        font-size: 21px;
                        font-weight: normal;
                    }
                    .icon.icon-check {
                        margin-right: 10px;
                    }				
                }

                .explanation {
                    font-size: 12px;
                    letter-spacing: 0;
                    color: white;
                    margin-bottom: 15px;
                }
            }

            .fare-info {
                font-size: 12px;
                color: #767676;
                line-height: 16px;
            }

            .detail {
                color: #333333;
                background-color: #ffffff;
                margin: 15px 0px;
                padding: 30px;
                font-size: 14px;
                border-radius: 12px;
                //height: 283px;

                @media (max-width: $max-mobile-res) {
                    padding: 20px 15px;
                }

                .row {
                    margin-bottom: 15px;
                    &:last-child {
                        margin-bottom: 0px;
                    }
                }
                
                
                .summary-title {
                    font-size: 16px;
                    font-weight: bold;
                    line-height: 14px;
                    margin-bottom: 20px;
                    color: #333333;
                }

                
                .fare-name {
                    font-size: 16px;
                    font-weight: bold;
                }

                .fare-price {
                    margin-top: -7px;
                    text-align: right;
                    .price {
                        font-size: 30px;
                        font-weight: bold;
                    }
                    .secondyear,
                    .unit {
                        font-size: 16px;	
                        margin-top: -5px;		
                    }
                }
            }
        }

        .questions {
            .btn {
                    position: absolute;
                    width: 100%;
                    left: 0px;
                    bottom: 40px;
                }
            
        }

        .note {
            font-size: 12px;
            color: #767676;
            margin: 20px 0px;
        } 

        
        .btn-container {
            display: flex;
            justify-content: center; 

            .btn-single {
                margin-right: 15px;

                @media (max-width: $max-mobile-res) {
                    margin-right: 0px;
                    margin-bottom: 40px;

                    &:last-child {
                        margin-bottom: 0px;
                    }
                }

                button {
                    margin-bottom: 0px;
                    margin-right: 0px !important;
                }
            }
        }

        .btn-container.large {
            @media (max-width: $max-mobile-res) {
                    align-items: center;
                    flex-direction: column;	
                } 
        }

            
        button {		
            color: #767676;
            font-size: 16px;
            background-color: white;
            width: 120px;
            height: 97px;
            border-radius: 10px;
            border: none;
            margin-right: 15px;
            border-bottom: 5px solid transparent;
            padding: 0px;

            +.explain {
                margin-top: 10px;
                font-size: 16px;
                color: #767676; 
                text-align: center;

                @media (max-width: $max-mobile-res) {
                    font-size: 14px;
                }
            }

            &:hover {
                box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.14);
            }

            &:last-child {
                margin-right: 0px;
            }

            &.longbutton {
                width: 250px;
                height: 70px;
                font-size: 16px;
                padding: 10px 20px;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;	

                @media (max-width: $max-mobile-res) {
                    margin-bottom: 20px;
                    margin-right: 0px;	
                } 

                .text {
                    max-width: 210px; // IE11 FIX
                }
            }

            &.yesnobutton {
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;	
                width: 390px;
                height: 70px;

                @media (max-width: $max-mobile-res) {
                    width: 250px;
                    margin-bottom: 15px;
                    margin-right: 0px;	
                } 
            }

            &.iconbutton {
                width: 165px;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                
                @media (max-width: $max-mobile-res) {
                    width: 97px;

                    &.alternative-width {
                        width: 150px;
                    }
                }
                

                .text {
                    font-size: 16px;
                    line-height: 1.13;
                    padding-top: 10px;
                    letter-spacing: -0.6px;
                }
                .icon {
                    font-size: 22px;
                }

                .text-min {
                    font-size: 18px;
                    line-height: normal;
                }

                .icon-cont {
                    height: 25px;
                    display: flex;
                }

            }


            &.large {
                width: 100%;
                min-width: 330px;
                height: 101px;
                margin-bottom: 15px;
                font-size: 20px;
                text-align: left;

                .details {
                    font-size: 14px;

                    div {
                        padding: 0px 10px;
                        margin-top: 10px;
                    }				
                }

                .icon.icon-monoraria {
                    margin-right: 15px;
                }
            }

            &.active {
                color: #333;
                font-weight: bold;
                border-bottom: 5px solid #ffd300;
                //border-top: 5px solid white;
                box-shadow: 0 10px 12px 0 rgba(0, 0, 0, 0.3);
                box-sizing: border-box;
            }
        }

        .sf-btn.btn--confirm.off {
            opacity: 0.5;
            pointer-events: none;
        }

        .sf-btn.btn--confirm {
            font-size: 20px;
            font-weight: normal;
            color: #333;
            background-color: white;
            width: 270px;
            height: 50px;
            border-radius: 3px;
            text-transform: none;

            @media (max-width: $max-mobile-res) {
                width: 300px;
            }
        }

        

        .sf-btn.btn--confirm.mb {
            margin-bottom: 120px;
        }

        .sf-btn.btn--confirm.mt {
            margin-top: 40px;
            margin-bottom: 100px;
        }

        .exitway {
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            position: fixed;
            z-index: 1000;
            /* width: 100vw; */
            /* height: 100vh; */
            color: #444;
            font-size: 16px;
            display: flex;
            justify-content: center;
            align-items: center;
            

            .exitway_cont {
                border-radius: 12px;
                width: 1004px;
                height: 637px;
                background-color: #f3f3f3;
                overflow: hidden;
                
                @media (max-width: $max-mobile-res) {
                    width: 100%;
                    height: 100vh;
                    border-radius: 0px;
                }
            }

            a {
                font-weight: bold;
                cursor: pointer;
            }

            .row.padded {
                padding: 0px 90px;
                
                .bordered:first-child {
                    border-right: 1px solid #d9d9d9;
                    
                    @media (max-width: $max-mobile-res) {
                        border-right: 0px;
                    } 
                }
                

                @media (max-width: $max-mobile-res) {
                    display: flex;
                    flex-direction: column-reverse;
                    padding: 0px;
                }       
            }

            

            .header {
                background-color: #fff;
                font-size: 18px;
                font-weight: bold;
                color: #333333;
                letter-spacing: 0.5;
                z-index: 1010;
                height: 70px;

                .title {
                    background: linear-gradient(to bottom,transparent 70%,#fdd300 70%,#fdd300 0);
                    display: inline-block;
                    position: relative;
                    
                    &:before {
                        content: '\e97d';
                        font-family: EGL-Icon-font;
                        font-weight: 600;
                        font-size: 10px;
                        transition: all .2s ease-in-out;
                        position: absolute;
                        top: 50%;
                        left: -20px;
                        transform: translateY(-50%) rotate(270deg);
                        line-height: 20px;
                    }

                }
            }

            .container.inside {
                padding-top: 30px;
                /* padding-bottom: 50px; */
                height: 567px;
                overflow-y: hidden;
                

                @media (max-width: $max-mobile-res) {
                    padding-bottom: 120px;
                    height: 100vh;
                    overflow-y: scroll;
                }        
            }

            .container.withimage {
                padding-top: 30px;
                padding-right: 420px;
                height: 567px;
                overflow-y: hidden;
                margin-left: 0;  

                @media (max-width: $max-mobile-res) {
                    padding-left: 15px;
                    padding-right: 15px;
                    height: 100vh;
                    overflow-y: scroll;
                }        
            }

            .container.padded {
                padding-top: 78px;
                padding-bottom: 50px;
                height: 100vh;
                overflow-y: hidden;

                .bordered:first-child {
                    border-right: 1px solid #d9d9d9;
                    overflow-y: scroll;
                }
            }

            
            .claim-container {
                position: relative;

                .claim {
                    font-size: 20px;
                    color: #333333;
                    padding-left: 15px;
                    margin-bottom: 10px;
                    z-index: 1000;
                    
                    @media (max-width: $max-mobile-res) {
                        margin-bottom: 0px;
                    }    
                }

                .subclaim {
                    font-size: 16px;
                    padding-left: 15px;
                }

                &:before {
                        content: '';
                        width: 6px;
                        height: 45px;
                        border-radius: 3px;
                        background-color: #fdd300;
                        position: absolute;
                        top: 50%;
                        transform: translateY(-50%);
                        left: 0;

                        @media (max-width: $max-mobile-res) {
                            width: 3px;
                        } 
                }
            }


            .exitbox {
                
                width: 330px;
                margin: 30px auto 15px auto;

                @media (max-width: $max-mobile-res) {
                    background-color: white;
                    border-radius: 15px;
                    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);
                }    

                &.exitbox-ko {
                text-align: center;
                color: #333;
                width: 380px;

                @media (max-width: $max-mobile-res) {
                    width: 330px;
                }

                    strong {
                        font-size: 20px;
                    }

                    .bodybox {
                        padding: 15px 15px 30px 15px;
                    }

                    .icon.big {
                        font-size: 80px;
                        display: inline-block;
                        margin: 30px auto 20px auto;
                    }
                }

                &.plain {
                    background-color: white;
                    border-radius: 15px;
                    .bodybox {
                        .text {
                            margin: 0;
                        }
                    }
                }

                button.more {
                    margin-top: 15px;
                }

                .headerbox {
                    //background-color: gray;
                    padding: 15px 30px;
                    color: white;
                    border-radius: 15px 15px 0px 0px;
                    border-bottom: 2px solid #d9d9d9;

                    @media (max-width: $max-mobile-res) {
                        border-bottom: none;
                    }

                    &.success {
                        color: #7fa545;

                        @media (max-width: $max-mobile-res) {
                            color: white;
                            background-color: #7fa545;
                        }
                    }

                    &.new {
                        color: #917ba8;

                        @media (max-width: $max-mobile-res) {
                            color: white;
                            background-color: #917ba8;;
                        }
                    }

                    &.alert {
                        //color: #ffb86f;
                        color: #7fa545;

                        @media (max-width: $max-mobile-res) {
                            color: white;
                            background-color: #7fa545;
                        }
                    }

                    &.ko {
                        color: #ff4d6c;

                        @media (max-width: $max-mobile-res) {
                            color: white;
                            background-color: #ff4d6c;
                        }
                    }

                    &.success .offer,
                    &.alert .offer {
                        font-size: 40px;
                        font-weight: bold;
                        line-height: 42px;

                        @media (max-width: $max-mobile-res) {
                            font-size: 30px;
                            line-height: 32px;
                        }
                    }

                    &.new .offer{
                        font-size: 30px;
                        font-weight: bold;
                        line-height: 32px;

                        @media (max-width: $max-mobile-res) {
                            font-size: 30px;
                            line-height: 32px;
                        }
                    }

                    .supply {
                        font-size: 20px;
                        font-weight: bold;
                        text-transform: uppercase;
                    }
                }

                
            }

            .bodybox {
                font-size: 16px;
                padding: 15px 30px 30px 30px;
                
                .text {
                    margin-bottom: 30px;
                    border-radius: 12px;
                    background-color: white;
                    padding: 10px 17px;
                }

                .text-docs {
                    margin-bottom: 30px;

                    ul {
                        margin-top: 15px;
                    }

                    ul li {
                        margin-bottom: 15px;
                        position: relative;
                        padding-left: 25px;

                        &:before {
                            content: '\e97c';
                            font-family: EGL-Icon-font;
                            font-weight: 600;
                            font-size: 15px;
                            transition: all .2s ease-in-out;
                            position: absolute;
                            color: #0885ae;
                            left: 0px;
                        }
                    }
                }
            }

            .underbox-title {
                color: #444444;
                font-size: 18px;
                font-weight: bold;
                line-height: 24px;
                margin-bottom: 5px;
                padding: 0px 15px;
            }

            .underbox-text {
                color: #444444;
                font-size: 16px;
                padding: 0px 15px;

                a {
                    font-weight: bold;
                    color: #444444;
                    text-decoration: underline;
                }
            }


            button {
                width: 100%;
                height: 50px;
                font-size: 20px;
                color: #333333;
                background-color: #ffd300;
                border-radius: 5px;
            }
        }

        .configSummary {
            top: 0;
            left: 0;
            position: fixed;
            z-index: 2000;
            width: 100vw;
            height: 100vh;
            color: #444444;
            font-size: 16px;
            overflow-y: scroll;
            padding-bottom: 40px;
            letter-spacing: normal;

            .header {
                background-color: #f4f4f4;
                font-size: 18px;
                font-weight: bold;
                color: #333333;
                letter-spacing: 0.5;
                height: 140px;

                .title {
                    background: linear-gradient(to bottom,transparent 70%,#fdd300 70%,#fdd300 0);
                    display: inline-block;
                    position: relative;
                    margin-bottom: 30px;

                    
                    &:before {
                        content: '\e97d';
                        font-family: EGL-Icon-font;
                        font-weight: 600;
                        font-size: 10px;
                        transition: all .2s ease-in-out;
                        position: absolute;
                        top: 50%;
                        left: -20px;
                        transform: translateY(-50%) rotate(270deg);
                        line-height: 20px;
                    }

                }

                .decoration {
                    top: 73px;
                    height: 30px;
                }

                .steptitle {
                    font-weight: normal;
                    margin-bottom: 3px;
                }

                .substeptitle {
                    font-size: 15px;
                    font-weight: normal;
                    letter-spacing: normal;
                }
            }

            .content {
                margin-top: 160px;
                padding: 0px 15px 0px 35px;
                margin-bottom: 50px;
                position: relative;
            }

            .stepchoice {
                color: white;
                margin-bottom: 30px;

                &:before {
                    content: '';
                    position: absolute;
                    width: 1px;
                    background-color: white;
                    top: 10px;
                    bottom: 180px;
                    left: 20px;
                }

                
                &.shortline { 
                    &:before {
                        content: '';
                        position: absolute;
                        width: 1px;
                        background-color: white;
                        top: 10px;
                        bottom: 90px;
                        left: 20px;
                    }
                }
                

                .questionNumber {
                    font-size: 14;
                    position: relative;

                    &:after {
                        content: '';
                        position: absolute;
                        width: 11px;
                        height: 11px;
                        border-radius: 50%;
                        background-color: white;
                        top: 6px;
                        left: -20px;
                    }
                }

                .question {
                    font-size: 20px;
                    font-weight: bold;
                    
                    &.more {
                        margin-top: 15px;
                    }

                }

                .info {
                    color: white;
                    font-size: 14px;
                    font-weight: bold;
                    margin-top: 15px;

                    .icon {
                        margin-right: 7px;
                    }
                }

                .answer {
                    margin-top: 10px;
                    width: 200px;
                    height: 40px;
                    background-color: white;
                    border-bottom: solid 5px #ffd300;
                    border-radius: 8px;
                    text-transform: uppercase;
                    color: #333333;
                    font-size: 18px;
                    font-weight: bold;
                    text-align: center;
                    padding-top: 7px;
                    position: relative;
                    padding-right: 20px;

                    &:before {
                        content: '\e9c8';
                        font-family: EGL-Icon-font;
                        font-weight: 600;
                        font-size: 15px;
                        transition: all .2s ease-in-out;
                        position: absolute;
                        top: 25%;
                        right: 10px;
                        line-height: 20px;
                        color: #333333;
                    }
                }
            }
        }
    }

</style>